module.exports = __webpack_public_path__ + "static/media/CheckDetailsScreen.491acb80.png";